import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { PhoneOff } from 'lucide-react';

export default function NotFound() {
  return (
    <div className="page notfound">
      <motion.span initial={{ rotate: -30, scale: 0.5 }} animate={{ rotate: 0, scale: 1 }} transition={{ type: 'spring' }}>
        <PhoneOff size={64} />
      </motion.span>
      <h1><span className="grad-text">404</span> Not Found</h1>
      <p>lookup("location") came back empty. That page is not registered here.</p>
      <Link className="btn btn-primary" to="/">Back to the steps</Link>
    </div>
  );
}
